// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

const UserStateController = function ($rootScope, $scope, $http, $routeParams, $window, $location, User, Features, AccountSettings, IdentityProviderSettings, gettextCatalog) {
    // Init user roles for binding them to UI
    $scope.user = {
        Mandates: [
            { Roles: [] }
        ]
    };

    $scope.isSsoFeatureActive = function () {
        return $rootScope.features.OpenIdConnect || $rootScope.features.AzureActiveDirectory;
    }

    $scope.UserType = Object.freeze({
        "External": "External",
        "Internal": "Internal"
    });

    $scope.ExternalRoleAssignmentStrategy = Object.freeze({
        "NoExternalRoleAssignments": "NoExternalRoleAssignments",
        "RolePerLegalEntity": "RolePerLegalEntity",
        "OneRoleForAllLegalEntities": "OneRoleForAllLegalEntities"
    });

    $scope.ThirdPartyIntegrations = Object.freeze({
        "OpenIdConnect": "OpenIdConnect",
        "AzureActiveDirectory": "AzureActiveDirectory"
    });

    const pageSize = 100;

    $scope.defaultCulture = 'en';

    $scope.defaultLocaleByCompanyCountry = Object.freeze(
        {
            'de': ['DE', 'AT', 'CH'],
            'fr': ['FR'],
            'nl': ['NL', 'BE'],
            'sv': ['SE'],
            'no': ['NO'],
            'da': ['DK'],
            'ru': ['RU'],
            'es': ['ES']
        });

    $scope.languages = $rootScope.getLanguages();

    $scope.companySettings = AccountSettings.get();

    $scope.getDefaultUserCulture = function () {
        if ($scope.companySettings.InvoiceAddress.Country) {
            Object.keys($scope.defaultLocaleByCompanyCountry).forEach(function (key, index) {
                if ($scope.defaultLocaleByCompanyCountry[key].includes(($scope.companySettings.InvoiceAddress.Country))) {
                    $scope.defaultCulture = key;
                }
            });
        }
        else {
            $scope.defaultCulture = 'en';
        }
    }

    $scope.selectedEntity = [];
    $scope.selectedEntities = [];

    const multiSelectStates = Object.freeze({
            NonInitialized: 0,
            OutputAsTree: 1,
            PendingForSearch: 2,
            SearchResultAsList: 3,
            SearchResultAsTree: 4,
        });

    $scope.TenantEntities = {
        newState: multiSelectStates.NonInitialized,
        items: []
    };

    $scope.currentMandate = {};

    $scope.IsEditMode = function () {
        return $routeParams.userId !== null && $routeParams.userId !== undefined;
    }

    $scope.loadPage = function () {

        $http.get('/api/v1/users/roles').then(function (result) {
            $scope.userRoles = result.data;
            //Sort role alphabetically
            $scope.userRoles.sort(function (a, b) {

                var a_translated = gettextCatalog.getString(a);
                var b_translated = gettextCatalog.getString(b);

                if (a_translated < b_translated) {
                    return -1;
                }
                if (a_translated > b_translated) {
                    return 1;
                }
                return 0;
            });
        });

        Features.loadingAsPromise().then(
            function (response) {
                const features = response.data;
                $scope.isTenant = features.includes('TenantHierarchy');
                if ($scope.isTenant) {
                    $scope.loadEntities();
                    $scope.loadEntitiesForSelectTree('', null, multiSelectStates.NonInitialized);
                }
                if ($scope.IsEditMode()) {
                    $http.get('/api/v1/users', {params: {id: $routeParams.userId}}).then(function (result) {
                        $scope.user = result.data;
                    });
                } else {
                    setEmptyUserModel();
                }
            },
            function (error) {
                console.log(error);
                $scope.isTenant = false;
            }
        );
        
        if ($scope.isSsoFeatureActive()) {
            IdentityProviderSettings.get().$promise.then(function (response) {
                $scope.externalIdentityServiceSettings = response;
                $scope.externalIdentityServiceSettingsIsActive = $scope.externalIdentityServiceSettings?.Active && $scope.externalIdentityServiceSettings?.Valid;
                $scope.shouldExternalUserRolesVisible = 
                    $scope.externalIdentityServiceSettings?.ExternalRoleAssignmentStrategy === $scope.ExternalRoleAssignmentStrategy.NoExternalRoleAssignments;
                $scope.isAzureIntegration = $scope.externalIdentityServiceSettings?.ThirdPartyIntegration === $scope.ThirdPartyIntegrations.AzureActiveDirectory;
                $scope.isOpenIdIntegration = $scope.externalIdentityServiceSettings?.ThirdPartyIntegration === $scope.ThirdPartyIntegrations.OpenIdConnect;
            });
        }
    }
    
    $scope.isExternalUser = function () {
        return $scope.user.UserType === $scope.UserType.External;
    }
    
    $scope.loadPage();

    $scope.loadEntitiesForSelectTree = function (searchQuery, searchEntityId, treeState) {
        $http.get('/api/v1/legalEntities', { params: { take: pageSize, entityId: searchEntityId, search: searchQuery } }).then(function (result) {
            switch (treeState) {
                case multiSelectStates.NonInitialized:
                case multiSelectStates.OutputAsTree:
                    $scope.TenantEntities.items = convertEntityListToTree(result.data);
                    $scope.TenantEntities.newState = multiSelectStates.OutputAsTree;
                    break;
                case multiSelectStates.PendingForSearch:
                    $scope.TenantEntities.items = result.data;
                    $scope.TenantEntities.newState = multiSelectStates.SearchResultAsList;
                    break;
                case multiSelectStates.SearchResultAsList:
                    if (searchEntityId) {
                        result.data[0].ParentId = null;
                        $scope.TenantEntities.items = convertEntityListToTree(result.data);
                        $scope.TenantEntities.newState = multiSelectStates.SearchResultAsTree;
                    }
                    break;
            }
        });
    }

    $scope.loadEntities = function () {
        $http.get('/api/v1/legalEntities', { params: { take: pageSize } }).then(function (result) {
            $scope.enList = result.data;

            if ($scope.IsEditMode()) {
                $http.get('/api/v1/users', { params: { id: $routeParams.userId } }).then(function (result) {
                    $scope.user = result.data;
                    if ($scope.isTenant) {
                        setupUserRoles();
                    }
                });
            }
            else {
                setEmptyUserModel();
                if ($scope.isTenant) {
                    setupUserRoles();
                }
            }
        });
    }

    $scope.addSelectedEntity = function () {

        let isEntityNotAlreadySelected = !$scope.selectedEntities.some(function (entity) {
            return entity.Id === $scope.selectedEntity[0].Id;
        });

        if (isEntityNotAlreadySelected) {
            if (!$scope.selectedEntity[0].Roles) {
                $scope.selectedEntity[0].Roles = [];
            }
            $scope.selectedEntities.push($scope.selectedEntity[0]);
        }
    }

    $scope.removeFromSelectedEntities = function (entityId) {
        $scope.selectedEntities = $scope.selectedEntities.filter(function(entity) {
            return entity.Id !== entityId;
        });
    }

    $scope.saveChanges = function (addAnother) {
        if ($scope.IsEditMode()) {
            putUserChanges();
        } else {
            saveAndInviteUser(addAnother);
        }
    }

    $scope.shouldRolesBeVisible = function (userType) {
        return userType === $scope.UserType.Internal || $scope.isSsoFeatureActive() && $scope.shouldExternalUserRolesVisible;
    }

    $scope.$watch('user.UserType', function(newValue, oldValue) {
        $scope.selectedEntities.length = 0;
    });

    function setEmptyUserModel() {
        $scope.companySettings.$promise.then(function() {
            $scope.getDefaultUserCulture();
            {
                let newUser = {
                    EmailAddress: '',
                    UserInformation: {
                        FirstName: '',
                        LastName: '',
                        Culture: $scope.defaultCulture
                    },
                    UserType: $scope.isSsoFeatureActive() ? $scope.UserType.External : $scope.UserType.Internal,
                    Mandates: []
                };
    
                if (!$scope.isTenant) {
                    newUser.Mandates[0] = {
                        Roles: []
                    }
                }
                $scope.user = newUser;
            }
        });
    }

    //For IsEditMode == true => iterate through userDto model and added all his mandates (entity + role list) as selected.
    function setupUserRoles() {
        for (let i = 0; i < $scope.user.Mandates.length; i++) {
            let currentEntity = $scope.enList.find(function (entity) {
                return entity.Id === $scope.user.Mandates[i].EntityId;
            });
            currentEntity.Roles = $scope.user.Mandates[i].Roles;
            $scope.selectedEntities.push(currentEntity);
        }
    }

    function saveAndInviteUser(addAnother) {
        if ($scope.isTenant) {
            applyChangesForUserRoles();
        }
        $http.post('/api/v1/users/', $scope.user).then(function (response) {
            if (response.status === 201) {
                if (addAnother) {
                    $window.location.reload();
                } else {
                    $location.path("/account-settings/users");
                }
            }
        }, function () {
            if ($scope.isTenant) {
                $scope.user.Mandates = [];
            }
        });
    }

    function putUserChanges() {

        applyChangesForUserRoles();

        $http.put('/api/v1/users/', $scope.user).then(function (response) {
            if (response.status === 200) {
                $location.path("/account-settings/users");
            }
        }, function () {
            if ($scope.isTenant) {
                $scope.user.Mandates = [];
            }
        });
    }

    //iterate through selected entities and add their configuration to user dto model
    function applyChangesForUserRoles() {
        for (let i = 0; i < $scope.selectedEntities.length; i++) {
            $scope.user.Mandates[i] =
            {
                EntityId: $scope.selectedEntities[i].Id,
                Roles: $scope.selectedEntities[i].Roles
            }
        }
    }

    //TODO: review. Convert list of entities to tree structure and return it 
    function convertEntityListToTree(list) {
        let map = {}, node, roots = [], i;

        for (i = 0; i < list.length; i += 1) {

            //Hack - here added some props, which will be needed later. 
            // Better move it from here to separate method
            list[i].name = list[i].Name;
            if (!$scope.IsEditMode) {
                list[i].Roles = [];
            }

            map[list[i].Id] = i;
            list[i].children = [];
        }

        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.ParentId) {
                list[map[node.ParentId]].children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }
};
UserStateController.$inject = ['$rootScope', '$scope', '$http', '$routeParams', '$window', '$location', 'User', 'Features', 'AccountSettings', 'IdentityProviderSettings', 'gettextCatalog'];
